import React, { useState } from "react";
import { Container, Button, Image, Badge } from "react-bootstrap";
import SharedPagination from "../../../../../components/Pagination";
import PageLoader from "../../../../../components/PageLoader";
import { MdOutlineChat } from "react-icons/md";
import { useGetMenteeByUserIdQuery } from "../../../../../../services/counselling-service";
import Feedback from "./Feedback";
import ViewCounsellorFeedback from "./ViewCounsellorFeedback";

const CounselleeBody = ({ searchQuery }) => {
  const [userid] = useState(sessionStorage.getItem("userId"));
  const userId = Number(userid);

  const [currentPageIndex, setCurrentPageIndex] = useState(0);

  const [openfeedback, setOpenFeedback] = useState(false);
  const [openCounsellorFeedback, setOpenCounsellorFeedback] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(null);

  const [pageSize] = useState(10);

  const {
    data: response,
    isLoading,
    refetch,
  } = useGetMenteeByUserIdQuery({
    userId,
    page_index: currentPageIndex,
    page_size: pageSize,
  });

  const filteredData =
    response?.data.filter((counsellor) =>
      Object.values(counsellor).some((value) =>
        String(value).toLowerCase().includes(searchQuery.toLowerCase())
      )
    ) || [];

  const totalPages = response?.totalPages || 0;
  const totalElements = response?.totalElements || 0;

  const handleFeedbackRequest = (data) => {
    setSelectedRequest(data);
    setOpenFeedback(true);
  };

  const handleViewFeedbackRequest = (data) => {
    setSelectedRequest(data);
    setOpenCounsellorFeedback(true);
  };

  if (isLoading) {
    return <PageLoader />;
  }

  if (filteredData.length === 0) {
    return (
      <section className="py-5 py-lg-5 position-relative overflow-hidden">
        <Container>
          <div className="mw-4xl mx-auto mb-4 rounded-5 position-relative text-center py-5">
            <h4>No assignees found</h4>
            <p className="text-muted">
              {searchQuery
                ? "No matching assignees for your search"
                : "You currently have no assignees"}
            </p>
          </div>
        </Container>
      </section>
    );
  }
  return (
    <section className="py-5 py-lg-5  position-relative overflow-hidden">
      <Container>
        <div className="mw-4xl mx-auto mb-4 rounded-5 position-relative">
          {filteredData.map((data, index) => (
            <Button
              key={index}
              variant="outline-white"
              className="w-100 py-3 ps-3 pe-5 mb-3 text-start border rounded-5 position-relative"
            >
              <div className="d-flex w-100 justify-content-between align-items-center">
                <div
                  className={`mw-lg  ${
                    data.confirmation.completed ? "opacity-25" : ""
                  }`}
                >
                  <div className="d-flex mb-2 align-items-center">
                    <span className="fs-6 text-primary">
                      {data.requestType}
                    </span>
                    <span className="mx-2">·</span>
                    <span className="fs-6 text-secondary">
                      {data.referenceCode}
                    </span>
                  </div>
                  <h6 className="mb-1">
                    {" "}
                    Start Date:{" "}
                    {data.confirmation.startAt
                      ? new Date(data.confirmation.startAt).toLocaleDateString()
                      : ""}{" "}
                    -{" "}
                    {data.confirmation.startAt
                      ? new Date(data.confirmation.startAt).toLocaleTimeString()
                      : ""}
                  </h6>
                  <h6 className="mb-3">
                    {" "}
                    End Date:{" "}
                    {data.confirmation.endAt
                      ? new Date(data.confirmation.endAt).toLocaleDateString()
                      : ""}{" "}
                    -{" "}
                    {data.confirmation.endAt
                      ? new Date(data.confirmation.endAt).toLocaleTimeString()
                      : ""}
                  </h6>
                  <div>
                    <p style={{ fontSize: "12px" }} className="mb-1 p-0">
                      Counsellor
                    </p>
                    {data.confirmation.counsellors.map((item, index) => (
                      <Badge
                        pill
                        bg="light"
                        className="me-1 px-2 py-1 fw-normal text-dark"
                        key={index}
                        style={{ fontSize: "14px" }}
                      >
                        <Image
                          src={`https://ui-avatars.com/api/?name=${item.firstName}+${item.lastName}&background=random&size=30`}
                          alt="Avatar"
                          roundedCircle
                          className="pe-1"
                        />
                        {item.firstName} {item.lastName}
                      </Badge>
                    ))}
                  </div>
                </div>
                <div>
                  {data.confirmation.completed && (
                    <>
                      <div>
                        <Button
                          onClick={() => handleFeedbackRequest(data)}
                          className="border-0 bg-transparent p-0 mt-2 text-black opacity-100"
                        >
                          <MdOutlineChat /> Send Feedback
                        </Button>
                      </div>
                      <div>
                        <Button
                          className="opacity-100"
                          onClick={() => handleViewFeedbackRequest(data)}
                          variant="dark rounded-5"
                          style={{ fontSize: "13px" }}
                        >
                          View Counsellor's Feedback
                        </Button>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </Button>
          ))}
        </div>
      </Container>

      <SharedPagination
        currentPage={currentPageIndex + 1}
        onPageChange={(newPage) => setCurrentPageIndex(newPage - 1)}
        totalPages={totalPages}
        pageSize={pageSize}
        totalElements={totalElements}
      />

      <Feedback
        request={selectedRequest}
        show={openfeedback}
        onClose={() => setOpenFeedback(false)}
      />

      <ViewCounsellorFeedback
        request={selectedRequest}
        show={openCounsellorFeedback}
        onClose={() => setOpenCounsellorFeedback(false)}
      />
    </section>
  );
};

export default CounselleeBody;
